/**
 * @module rocasset/refreshassetcommand
 */

import { Command } from '@ckeditor/ckeditor5-core';

/**
 * This command is used to refresh the roc assets urls and alt text in the editor based on the asset id and dimension.
 */
export default class RefreshRocAssetsCommand extends Command {
	constructor(editor) {
		super(editor);
		this.isEnabled = true;
	}

	execute(update, records) {
		const model = this.editor.model;
		const docRoot = this.editor.model.document.getRoot();
		const rocAsset = this.editor.config.get('rocasset') || null;
		const assetsToRefresh = [];
		if (rocAsset.refreshAction) {
			model.change((writer) => {
				updateAssets(docRoot);

				function updateAssets(modelElement) {
					if (modelElement.hasAttribute('rocasset')) {
						const rocAssetOld = JSON.parse(decodeURIComponent(JSON.stringify(modelElement.getAttribute('rocasset'))));
						if (update) {
							const rocAssetNew = rocAsset.refreshAction(rocAssetOld, records);
                            if(rocAssetNew){
                                writer.setAttribute('rocasset', rocAssetNew, modelElement);
                                if(rocAssetNew.url){
                                    writer.setAttribute('src', rocAssetNew.url, modelElement);                           
                                }
                                
                                if(rocAssetNew.altText){
                                    writer.setAttribute('alt', rocAssetNew.altText, modelElement);                           
                                }
                                
                                assetsToRefresh.push(rocAssetNew);
                            }else{
                                assetsToRefresh.push(rocAssetOld);
                            }
						} else {
							assetsToRefresh.push(rocAssetOld);
						}
					}
					for (let cIndex = 0; cIndex < modelElement.childCount; cIndex++) {
						updateAssets(modelElement.getChild(cIndex));
					}
				}
			});
		}
		return assetsToRefresh;
	}

	refresh() {}
}